import Box from '@/common/components/Box'
import { EmptyDataMessage } from '@/common/components/EmptyDataMessage'

const EstablishmentChoiceEntryProposalAwaitingEstablishmentResponse = () => {
  return (
    <Box className="p-4 flex items-center justify-center h-80 overflow-hidden">
      <EmptyDataMessage message="Estabelecimento ainda não respondeu" className="p-0 h-80" />
    </Box>
  )
}

export default EstablishmentChoiceEntryProposalAwaitingEstablishmentResponse
